var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgArrowT2BBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "7px",
    viewBox: "0 0 11 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img-arrow-t2b--black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u3054\\u4E88\\u7D04",
    transform: "translate(-785.000000, -854.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(150.000000, 721.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(315.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329,20 L329,21 L323,21 L323,27 L322,27 L322,20 L329,20 Z",
    id: "img-arrow-t2b--black",
    transform: "translate(325.500000, 23.500000) rotate(-135.000000) translate(-325.500000, -23.500000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgArrowT2BBlack);
export default __webpack_public_path__ + "static/media/img-arrow-t2b--black.9fe99a9139d705ef83bbd1be88f9a184.svg";
export { ForwardRef as ReactComponent };